import type { Texts } from '@/texts/getTexts'
import { ArbeidsforholdDetaljert, Arbeidstaker, Kodeverk, PrivatArbeidsgiver } from 'types/arbeidsforhold'

// Fødselsnummer er 11 siffer, organisasjonsnummer 9. Samme skille som formatFnrOrgnr bruker.
export const lagKopiAriaLabel = (ident: string, tekst: Texts, navn?: string | null) => {
    const erFnr = ident.length > 9
    if (navn) return (erFnr ? tekst.kopier.fnrMedNavn : tekst.kopier.orgnrMedNavn).replace('%s', navn)
    return erFnr ? tekst.kopier.fnr : tekst.kopier.orgnr
}

export const hjelpetekstAriaLabel = (tekst: Texts, felt?: string) =>
    felt ? tekst.hjelpetekst.om.replace('%s', felt[0].toLowerCase() + felt.slice(1)) : undefined

export const addTekstAndData = (data: string | number | null, tekst: string) => {
    if (!data) return null
    return tekst.replace('%s', data.toString())
}

export const settSammenNavn = (navn?: Arbeidstaker | PrivatArbeidsgiver): string => {
    const fulltNavn = [navn?.fornavn, navn?.mellomnavn, navn?.etternavn].filter(Boolean).join(' ')
    if (fulltNavn.length < 1 || !navn) {
        return '(Navn mangler)'
    }
    return capitalizeFirstLetterOfEachWord(fulltNavn)
}

export const settSammenBeskrivelseKode = (kodeverk: Kodeverk, typeKode: string) => {
    if (kodeverk === null) return null
    return `${kodeverk.beskrivelse} (${typeKode}: ${kodeverk.kode})`
}

export const hentBeskrivelse = (kodeverk?: Kodeverk | null) => {
    return kodeverk ? kodeverk.beskrivelse : null
}

export const capitalizeFirstLetter = (tekst: string | null) => {
    if (tekst === null) return null
    return tekst[0].toUpperCase() + tekst.substring(1).toLowerCase()
}

const capitalizeFirstLetterOfEachWord = (tekst: string) => {
    const words = tekst.split(' ')

    return words.map((word) => capitalizeFirstLetter(word)).join(' ')
}

export const hentNavn = (data?: ArbeidsforholdDetaljert['arbeidssted'] | ArbeidsforholdDetaljert['arbeidstaker']) => {
    switch (data?.type) {
        case 'person':
            return settSammenNavn(data)
        case 'arbeidstaker':
            return settSammenNavn(data)
        case 'organisasjon':
            return data.organisasjonsnavn ?? '(Navn mangler)'
        default:
            return '(Navn mangler)'
    }
}
